import React, { useState } from "react";
import { Button, Modal } from "semantic-ui-react";
import styled from "styled-components";
import { t } from "../../constant/translations";

export type DeleteProps = {
  entity: Object,
  del: ?Function,
  floated: ?string,
};

const DeleteButtonWrap = styled.div`
  cursor: pointer;
  text-align: center;

  > img {
    margin: auto auto;
  }
`;

const ConfirmDeleteButton = (props) => {
  return (
    <DeleteButtonWrap>
      <Button
        icon={"delete"}
        negative
        size={"medium"}
        content={t("common.confirm_deletion")}
        onClick={() => {
          props.del(props.entity);
        }}
      />
    </DeleteButtonWrap>
  );
};

export const DeleteModal = ({ entity, del, floated }: DeleteProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);

  const trigger = (
    <Button
      icon={"delete"}
      negative
      size={"tiny"}
      floated={floated}
      content={t("labels.deletion")}
      onClick={handleOpen}
    />
  );

  return (
    <Modal
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      closeIcon={"close"}
      trigger={trigger}
    >
      <Modal.Header>
        {t("common.want_to_delete")} {entity.name} {t("common.forever")}?
      </Modal.Header>
      <Modal.Content>{t("common.this_op_irreversible")}</Modal.Content>
      <Modal.Actions>
        <ConfirmDeleteButton entity={entity} del={del} />
      </Modal.Actions>
    </Modal>
  );
};
